/**
 * Build-time rollout flags.
 *
 * Some surfaces have a legitimate long-term home in the portal but are deliberately NOT part of the
 * current (Frontier AI) rollout. Rather than rip their code/routes out, we hide their navigation
 * entries behind a single flag so they can be switched back on in one place once they are ready.
 *
 * This is intentionally a coarse build-time hide (hidden for everyone), NOT per-user gating — the
 * frontend has no notion of a user's groups/roles, only a flat permission-slug set, so true
 * "developers only" visibility would require a new backend page permission + role. That is the
 * planned follow-up; until then these stay off for the rollout.
 */

/** Feature keys hidden from navigation for the current rollout. */
export const ROLLOUT_HIDDEN_NAV = {
  safe: true,
  assessment: true,
  labGeneration: true,
  labEvents: true,
} as const;

/** Admin submenu titles hidden for the current rollout (matched against SubMenuItem.title). */
export const ROLLOUT_HIDDEN_ADMIN_TITLES: ReadonlySet<string> = new Set([
  'Lab Generation',
  'Lab Event Management',
  'SAFE',
  'Assessments',
]);

/** Top-level nav item keys hidden for the current rollout (matched against NavItem.key). */
export const ROLLOUT_HIDDEN_NAV_KEYS: ReadonlySet<string> = new Set([
  'safe',
  'assessment',
]);
